import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";
import heroBg from "@/assets/hero-bg-optimized.webp";

export const Route = createFileRoute("/")({
  head: () =>
    buildHead({
      path: "/",
      jsonLd: buildFaqJsonLd(FAQS["/"].items),
      breadcrumbs: [{ name: "Home", url: SITE_URL }],
      links: [
        { rel: "preload", as: "image", href: heroBg, fetchpriority: "high", type: "image/webp" },
      ],
    }),
  component: Index,
});
